import React from 'react';
import './VCMessage.css';

const VCMessage = () => (
  <div className="page-container dark-red-theme">
    <h2>VC Message</h2>
    <p>Dummy content for VC Message page.</p>
  </div>
);

export default VCMessage;
